/* eslint-disable react/jsx-filename-extension */
import {
  POLK,
  WALMART,
  HEALTH_CONNECT_PLAN_PREFIX,
  HEALTH_CONNECT,
  EXTENDED_NETWORK,
} from 'utils/constants';
import { logDevMessage } from 'utils/utils';
import { PILL_KEYS } from './providerConstants';

const SUCCESS_MAIN = 'success.dark';
const ERROR_MAIN = 'error.main';

// eslint-disable-next-line import/prefer-default-export
export const getNetworkContent = ({ provider, network, client }) => {
  const { curatedOutNetwork, coeVendor: { coeVendorName } = {} } = provider;

  const networkContentOverrides = {
    [WALMART]: {
      inNetwork: {
        tooltipMessage:
          'This provider is in-network and has been designated by your medical plan as a preferred provider. You will receive your highest benefit when you get care from this provider.',
      },
      preferred: {
        networkText: 'In Network Preferred',
      },
      nonPreferred: {
        networkText: 'In Network Non-Preferred',
        textColor: ERROR_MAIN,
        tooltipMessage:
          'This provider is in-network but has been designated by your medical plan as a non-preferred provider. Your coverage will be lower when you get care from this provider.',
      },
    },
    [POLK]: {
      inNetwork: {
        showTooltip: true,
      },
    },
  };

  let networkContent = {
    networkText: 'In Network',
    textColor: SUCCESS_MAIN,
    tooltipMessage:
      'This provider has been designated as In Network by your medical plan. You will receive the highest benefit when you get care from an In Network provider.',
    showTooltip: false,
    showNetworkStatus: true,
  };

  // Walmart
  if (client === WALMART) {
    const nwa = network === 'northwestarkansas' || network === 'bcbsarkansas';
    const curatedOut = curatedOutNetwork === network || provider?.curatedOut;
    networkContent = { ...networkContent, ...networkContentOverrides[WALMART].inNetwork };

    if (!nwa) {
      networkContent.showTooltip = true;
      if (curatedOut) {
        networkContent = {
          ...networkContent,
          ...networkContentOverrides[WALMART].nonPreferred,
        };
      } else {
        networkContent = { ...networkContent, ...networkContentOverrides[WALMART].preferred };
      }
    }
  }

  // Polk
  if (client === POLK) {
    networkContent = { ...networkContent, ...networkContentOverrides[POLK].inNetwork };
  }

  if (coeVendorName) {
    networkContent.networkText = `${coeVendorName} Network`;
    networkContent.tooltipMessage = `This provider has been designated as a COE Network provider by ${coeVendorName}. A COE (Center of Excellence) is a healthcare center known for providing top-quality care for certain health conditions.`;
  }

  return networkContent;
};

export const getHealthPlanContent = (networkSlug, healthPlan) => {
  if (!healthPlan || networkSlug.toUpperCase() !== HEALTH_CONNECT_PLAN_PREFIX) return null;

  const healthPlanMap = {
    [HEALTH_CONNECT]: {
      text: 'Health Connect Network',
      tooltipMessage: `You'll generally pay less out of pocket when you receive care from a Health Connect provider versus an Extended Network provider.
        This Health Connect Network designation may not apply to all locations. Check the full profile page to see location-specific details.`,
      color: 'success.dark',
    },
    [EXTENDED_NETWORK]: {
      text: 'Extended Network',
      tooltipMessage:
        "You'll generally pay more out of pocket when you receive care from an Extended Network provider versus a Health Connect provider.",
      color: 'info.main',
    },
  };

  return healthPlanMap[healthPlan];
};

export const getFilteredPillOrBadgeList = (items /* accepts badges or pills */) =>
  items.filter((item) => {
    // remove null values
    if (!item) return false;
    // warn console and continue if pill.key is missing
    if (!item.key) logDevMessage(`'key' property is missing for badge or pill: ${item.label}`);
    // remove "low score" pill (or badge) if coe pill (or badge) is present
    if ([PILL_KEYS.SCORE_LOW, PILL_KEYS.SCORE_TIER_LOW].includes(item.key)) {
      return !items.some((p) => p?.key === PILL_KEYS.COE_PROVIDER);
    }
    return true;
  });
